module.exports = __webpack_public_path__ + "static/img/GlobalChat.6aeeb24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GlobalChat.png
// module id = VCwC
// module chunks = 1